export const NO_LIFT = 'No Lift';
export const NO_CONFIDENCE_LEVEL = 'No CL';
export const MISSING_VALUE = '--';
export const VISITS_THRESHOLD = 200;
